import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgEntityServiceLoader } from '@datorama/akita-ng-entity-service';
import { CsProjectsService } from './state/cs-projects.service';
import { CsProjectsQuery } from './state/cs-projects.query';
import { CsProject } from './state/cs-project.model';
import { MatDialog } from '@angular/material/dialog';
import { AddCsProjectDialogComponent } from './add-dialog/add-cs-project-dialog.component';
import { DeleteCsProjectDialogComponent } from './delete-dialog/delete-cs-project-dialog.component';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { csProjectStoreName } from './state/cs-project.store';
import { Guid } from 'guid-typescript';
import { finalize, map } from 'rxjs/operators';


@Component({
  selector: 'app-cs-projects',
  templateUrl: './cs-projects.component.html',
  styleUrls: ['./cs-projects.component.scss']
})
export class CsProjectsComponent implements OnInit, OnDestroy {
  cscProjects: CsProject[];

  private internalError: string;
  private internalIsBusy: boolean;
  private projectsSubscription: Subscription;
  private loaderSubscription: Subscription;
  private filterSubject$: BehaviorSubject<string>;

  public get error(): string {
      return this.internalError;
  }

  public get isBusy(): boolean {
    return this.internalIsBusy;
  }

  constructor(private query: CsProjectsQuery,
              private service: CsProjectsService,
              private loader: NgEntityServiceLoader,
              private dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) {
    this.filterSubject$ = new BehaviorSubject<string>(undefined);
  }

  ngOnInit(): void {
    this.projectsSubscription = combineLatest([this.query.selectAll(), this.filterSubject$.asObservable()])
      .pipe(map(([projects, searchInput]) => {
        return searchInput
          ? projects.filter(p => this.matches(p, searchInput.split(' ')))
          : projects; }))
      .subscribe(projects => {
        this.cscProjects = projects;
        console.log(projects); });

    this.loaderSubscription = this.loader.loadersFor(csProjectStoreName).get$.subscribe(
      isLoading => this.internalIsBusy = isLoading);

    if (this.query.getCount() === 0) {
      this.service
      .get<CsProject[]>()
      // without subscribing the store will be not initialized
      .subscribe(
        () => {},
        error => { this.internalError = error.message; });
    }
  }

  ngOnDestroy(): void {
    this.projectsSubscription.unsubscribe();
    this.loaderSubscription.unsubscribe();
  }

  openDeletProjectDialog(csProject: CsProject): void{
    this.dialog.open(DeleteCsProjectDialogComponent, { data: { csProject: {...csProject} } });
  }

  openAddCscProjectDialog(): void {
    const dialogRef = this.dialog.open(AddCsProjectDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate([result], { relativeTo: this.route });
      }
    });
  }

  copyProject(projectId: Guid): void {
    this.internalIsBusy = true;
    this.service.copyProject(projectId)
      .pipe(finalize(() => this.internalIsBusy = false))
      .subscribe();
  }

  setProjectsFilter(filterQuery: string): void {
    this.filterSubject$.next(filterQuery);
  }

  private matches(cscProject: CsProject, searchItems: string[]): boolean {
    return searchItems
      .map(si => si.toLowerCase())
      .every(si =>
        cscProject.projectName.toLowerCase().indexOf(si) >= 0 ||
        cscProject.chargingStationAddress.line1.toLowerCase().indexOf(si) >= 0 ||
        cscProject.chargingStationAddress.postalCode.toLowerCase().indexOf(si) >= 0 ||
        cscProject.chargingStationAddress.city.toLowerCase().indexOf(si) >= 0);
    }
}
